import React from 'react';
import { MegaMenuCTA } from 'src/components/Header/components/MegaMenu/MegaMenuCTA';
import { MegaMenuLink } from 'src/components/Header/components/MegaMenu/MegaMenuLink';
import { MegaMenuSectionTitle } from 'src/components/Header/components/MegaMenu/MegaMenuSectionTitle';
import CompanyCTAImage from 'images/megamenu/company-cta-image.jpg';
import { useMegaMenu } from 'src/components/Header/components/MegaMenu/useMegaMenu';

export const MegaMenuCompanyPage = () => {
  const { megaMenuState } = useMegaMenu();
  return (
    <div>
      <div className='grid grid-cols-2 xl:grid-cols-3 gap-x-10'>
        <div className='xl:col-span-2 grid grid-cols-1 xl:grid-cols-2 gap-x-10 gap-y-6 py-5'>
          <div className='flex flex-col gap-3'>
            <MegaMenuSectionTitle title='Company' to='/about-us'/>
            <div className='flex flex-col gap-4'>
              <MegaMenuLink
                label='About Us'
                to='/about-us'
                description='Our story. Our passion. Our role in elevating the fine and historic firearms field.'
                onPress={() => megaMenuState.close()}
              />
              <MegaMenuLink
                label='The Past That Drives Us'
                to='/consignment/the-past-that-drives-us'
                description={'Safeguarding and celebrating history\'s greatest treasures.'}
                onPress={() => megaMenuState.close()}
              />
            </div>
          </div>
          <div className='flex flex-col gap-3'>
            <MegaMenuSectionTitle title='Locations'/>
            <div className='flex flex-col gap-4'>
              <MegaMenuLink
                label='Bedford, TX'
                to='/location/bedford'
                onPress={() => megaMenuState.close()}
                description='Our international headquarters at 3600 Harwood Rd, Bedford, TX is the finest auction venue in the world.'
              />
              <MegaMenuLink
                label='Rock Island, IL'
                description='Our facilities at 7819 42nd St W, Rock Island, IL oversee every step of our production process.'
              />
            </div>
          </div>
        </div>
        <div className='w-full h-full'>
          <MegaMenuCTA
            onPress={() => megaMenuState.close()}
            to='/about-us' buttonLabel='Learn More' src={CompanyCTAImage} id='mega-menu-company-cta'
          />
        </div>
      </div>
    </div>
  );
};
